import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  paper: {
    overflow: 'hidden',
    borderRadius: 4,
    display: 'flex',
    position: 'relative',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.palette.colors.lightGray,
  },
  playerWrapper: {
    backgroundColor: theme.palette.colors.black,
    position: 'absolute',
    height: '100%',
    width: '100%',
  },
  player: {
    position: 'absolute',
    borderRadius: 4,
    zIndex: 1,
    overflow: 'hidden',
  },
  playerButtons: {
    zIndex: 5,
    position: 'absolute',
    width: 50,
    height: 50,
    top: '50%',
    left: '50%',
    marginTop: -25,
    marginLeft: -25,
    borderRadius: 25,
    cursor: 'pointer',
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
    '&:hover': {
      backgroundColor: theme.palette.colors.teal,
    },
  },
  hidden: {
    display: 'none',
  },
  blured: {
    filter: 'blur(4px)',
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/VideoPlayer/useStyles.js